import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { getStoredTokens } from 'utils/token';
import { MENU_CONFIG } from 'config/menuConfig';
import PlaceholderPage from 'pages/PlaceholderPage';
import Register from 'layouts/components/Account/Register';
import NewNotice from 'layouts/components/Notice/NewNotice';
import NoticeList from 'layouts/components/Notice/NoticeList';
 

const Login = React.lazy(() => import('../layouts/components/Account/Login'));
const Dashboard = React.lazy(() => import('../pages/Dashboard'));
const NotFound = React.lazy(() => import('../pages/NotFound'));
const MainLayout = React.lazy(() => import('../layouts/MainLayout'));
const CompanyInvitations = React.lazy(() => import('../layouts/components/Company/Invitations/CompanyInvitations')); // مسیر فایل را در صورت نیاز تغییر دهید
const OrganizationChart = React.lazy(() => import('../layouts/components/Company/Positions/OrganizationChart'));
const CompanyProfile = React.lazy(() => import('../layouts/components/Company/Profile/CompanyProfile'));
const UserProfile = React.lazy(() => import('../layouts/components/Account/Profile/UserProfile'));
const ChangePassword = React.lazy(() => import('../layouts/components/Account/ChangePassword')); 
const AddressManagement = React.lazy(() => import('../layouts/components/Company/Address/AddressManagement')); 


function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { accessToken } = getStoredTokens();
  if (!accessToken) return <Navigate to="/login" replace />;
  return <>{children}</>;
}

function buildMenuRoutes() {
  const routes: React.ReactNode[] = [];

 MENU_CONFIG.forEach(parent => {
    parent.children?.forEach(child => {
      if (!child.path) return;

      // اگر مسیر در تنظیمات منو برابر با صفحه دعوتنامه‌ها بود، کامپوننت اصلی را لود کن
      // در غیر این صورت همان Placeholder را نمایش بده
      if (child.path === 'partners/invitations' || child.path === '/partners/invitations') {
        routes.push(
          <Route
            key={child.key}
            path={child.path.replace(/^\//, '')} // حذف اسلش اول در صورت وجود
            element={<CompanyInvitations />}
          />
        );
      } 
      else if (child.path === 'company/org-chart'  || child.path === '/company/org-chart') {
        routes.push(
          <Route key={child.key} path={child.path.replace(/^\//, '')} element={<OrganizationChart />} />
        )}
          else if (child.path === 'company/info' || child.path === '/company/info') {
        routes.push(
          <Route key={child.key} path={child.path.replace(/^\//, '')} element={<CompanyProfile />} />
        );
      }
      else if (child.path === 'profile/personal/info' || child.path === '/profile/personal/info') {
        routes.push(
          <Route key={child.key} path={child.path.replace(/^\//, '')} element={<UserProfile />} />
        );
      }
       else if (child.path === 'profile/personal/password' || child.path === '/profile/personal/password') {
        routes.push(
          <Route key={child.key} path={child.path.replace(/^\//, '')} element={<ChangePassword />} />
        );
      }
       else if (child.path === 'company/addresses' || child.path === '/company/addresses') {
        routes.push(
          <Route key={child.key} path={child.path.replace(/^\//, '')} element={<AddressManagement />} />
        );
      }
      else if (child.path === 'advertisements/new' || child.path === '/advertisements/new') {
        routes.push(
          <Route key={child.key} path={child.path.replace(/^\//, '')} element={<NewNotice />} />
        );
      }
   else if (child.path === 'advertisements/all' || child.path === '/advertisements/all') {
        routes.push(
          <Route key={child.key} path={child.path.replace(/^\//, '')} element={<NoticeList />} />
        );
      }
      
        else {
        routes.push(
          <Route
            key={child.key}
            path={child.path.replace(/^\//, '')}
            element={<PlaceholderPage title={child.key} />}
          />
        );
      }
    });
  });

  return routes;
}

export default function AppRoutes() {
  return (
    <Routes>

      <Route path="/login" element={<Login />} />
       <Route path="/Register" element={<Register />} />


      <Route
        path="/"
        element={
          <ProtectedRoute>
            <MainLayout />
          </ProtectedRoute>
        }
      >
        <Route index element={<Dashboard />} />
        <Route path="dashboard" element={<Dashboard />} />
        
        {buildMenuRoutes()}

      </Route>

      <Route path="*" element={<NotFound />} />

    </Routes>
  );
}
